import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

export function getToken() {
  return localStorage.getItem("auth_token");
}

export function getUser() {
  try { return JSON.parse(localStorage.getItem("auth_user")); }
  catch { return null; }
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export async function login(username, password) {
  const { data } = await api.post("/auth/login", { username, password });
  localStorage.setItem("auth_token", data.token);
  localStorage.setItem("auth_user", JSON.stringify(data.user));
  return data.user;
}

export function logout() {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("auth_user");
}
